import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import {
  RouteParamsTypes, PermissionModulesEnum, PermissionActionsEnum,
  Modules,
  NonAuthRoutes
} from '../enums';
import ProtectedRoute from '../components/ProtectedRoute';
import ReservationList from '../modules/reservations/list';
import ReservationEditView from '../modules/reservations/editView';

const Reservations: React.FC = () => {
  return (
    <Routes>
      <Route path={RouteParamsTypes.blank} element={<ProtectedRoute component={ReservationList} accessibleTo={[{ [PermissionModulesEnum.Reservation]: [PermissionActionsEnum.View] }]} />} />
      <Route path={RouteParamsTypes.view + RouteParamsTypes.id} element={<ProtectedRoute component={ReservationEditView} accessibleTo={[{ [PermissionModulesEnum.Reservation]: [PermissionActionsEnum.View] }]} />} />
      <Route path={RouteParamsTypes.edit + RouteParamsTypes.id} element={<ProtectedRoute component={ReservationEditView} accessibleTo={[{ [PermissionModulesEnum.Reservation]: [PermissionActionsEnum.Update] }]} />} />
      <Route path={RouteParamsTypes.any} element={<Navigate replace to={{ pathname: Modules.error + NonAuthRoutes.notFound }} />} />
    </Routes>
  );
};

export default Reservations;
